interface NavigatorUAData {
  brands: { brand: string; version: string }[]
  mobile: boolean
  platform: string
  getHighEntropyValues: (hints: string[]) => Promise<{
    platform: string
    architecture?: string
    model?: string
    uaFullVersion?: string
  }>
}

// Extend Navigator type
interface Navigator {
  userAgentData?: NavigatorUAData
}
export const getBrowserAndOS = async (
  setSpecificOS: (os: string) => void,
  setSpecificBrowser: (browser: string) => void,
) => {
  let browser = 'Unknown Browser'
  let os = 'Unknown OS'

  if ('userAgentData' in navigator) {
    const uaData = await (navigator as any).userAgentData.getHighEntropyValues([
      'platform',
      'architecture',
      'model',
      'uaFullVersion',
    ])

    os = uaData.platform || 'Unknown OS'
    //useragentdata no soporta TS. Por eso el "any".
    if ((navigator as Navigator).userAgentData?.brands) {
      const detectedBrowser = [
        'Edge',
        'Chromium',
        'Chrome',
        'Firefox',
        'Safari',
      ].find((b) =>
        (navigator as Navigator).userAgentData?.brands.some(
          (brand: { brand: string; version: string }) =>
            brand.brand.includes(b),
        ),
      )
      browser =
        detectedBrowser === 'Chromium' || detectedBrowser === 'Chrome'
          ? 'Chrome'
          : detectedBrowser || 'Unknown Browser'
    }
  } else {
    const userAgent = navigator.userAgent

    const browserMatch = userAgent.match(
      /(Chromium|Firefox|Safari|Edge|Opera|MSIE|Trident)\/?\s*(\d+)/i,
    )
    browser = browserMatch ? browserMatch[1] : 'Unknown Browser'

    const osMatch = userAgent.match(/\(([^)]+)\)/)
    os = osMatch ? osMatch[1] : 'Unknown OS'
  }

  const userAgent = navigator.userAgent

  if (/SamsungBrowser/i.test(userAgent)) {
    browser = 'Samsung'
  } else if (/EdgiOS/i.test(userAgent) || /Edg/i.test(userAgent)) {
    browser = 'Edge'
  } else if (/CriOS/i.test(userAgent) || /Chrome/i.test(userAgent)) {
    browser = 'Chrome'
  } else if (/FxiOS/i.test(userAgent)) {
    browser = 'Firefox'
  } else if (
    /Safari/i.test(userAgent) &&
    !/CriOS|FxiOS|EdgiOS/i.test(userAgent)
  ) {
    browser = 'Safari'
  }

  const detectedOS =
    os.includes('macOS') || os.includes('Macintosh')
      ? 'Mac'
      : os.includes('Windows')
        ? 'Windows'
        : os.includes('Android')
          ? 'Android'
          : os.includes('iPhone')
            ? 'iPhone'
            : 'Unknown OS'
  setSpecificOS(detectedOS)
  setSpecificBrowser(browser)
}
